/**
 * Validation des identifiants PostgreSQL saisis par l'utilisateur
 * (nom de base additionnelle + user dedie).
 *
 * MIROIR de `AdditionalDatabase.validate_pg_identifier` /
 * `validate_password` dans nubicloud-api (`app/schemas/deployment.py`).
 * Toute evolution du validator backend doit etre repercutee ici, sinon on
 * reproduit l'incident du 2026-08-23 : un `savana-money` accepte cote UI,
 * refuse en 422 cote API.
 *
 * Pourquoi si strict : le SQL est interpole NON QUOTE, aussi bien dans
 * `additional_databases_sync_service._build_sync_sql` que dans le
 * postInitApplicationSQL du chart nubi-postgres. `CREATE DATABASE ma-base`
 * est une erreur de syntaxe, et la regex ferme la surface d'injection.
 */

/** Identifiant SQL utilisable sans quoting : minuscules, chiffres, `_`. */
export const PG_IDENTIFIER_RE = /^[a-z_][a-z0-9_]{0,62}$/;

export const PG_PASSWORD_MIN_LENGTH = 8;

/** true si l'identifiant passera le validator backend. */
export function isValidPgIdentifier(value: string): boolean {
  return PG_IDENTIFIER_RE.test(value);
}

/**
 * Proposition de correction pour un identifiant invalide — meme logique que
 * la suggestion du backend ("Exemple: savana_money").
 * @returns la suggestion, ou null si elle n'apporte rien (deja valide, ou
 *          toujours invalide apres normalisation).
 */
export function suggestPgIdentifier(value: string): string | null {
  const suggestion = value
    .trim()
    .toLowerCase()
    .replace(/[-\s.]+/g, '_')
    .replace(/[^a-z0-9_]/g, '')
    .replace(/_+/g, '_')
    .slice(0, 63);
  if (!suggestion || suggestion === value || !isValidPgIdentifier(suggestion)) return null;
  return suggestion;
}

/** true si le password passera le validator backend (apostrophe et `{{`/`}}` casseraient le SQL / le template Helm). */
export function isValidPgPassword(value: string): boolean {
  return (
    value.length >= PG_PASSWORD_MIN_LENGTH &&
    !value.includes("'") &&
    !value.includes('{{') &&
    !value.includes('}}')
  );
}
